import { z } from 'zod'

import { Pagination } from 'app/types/app/request'
import { ManagerBinding } from 'app/types/park/manager'

/** The provider of a product. */
export const Supplier = z.object({
    /** The ID of the supplier. */
    id: z.number().positive(),

    /** The name of the supplier. */
    name: z.string().min(1),

    /** The manager related. */
    client: ManagerBinding,

    /** The email of the supplier. */
    email: z.string().email().nullable(),

    /** The phone number of the supplier. */
    phone: z.string().nullable(),

    /** The address of the supplier. */
    address: z.string().nullable(),

    /** The postal code of the supplier. */
    postal_code: z.string().nullable(),

    /** The city of the supplier. */
    city: z.string().nullable(),

    // TODO: Replace with time later
    /** The opening hours of the supplier. */
    opening_hours: z.string().nullable(),

    // TODO: Replace with time later
    /** The closing hours of the supplier. */
    closing_hours: z.string().nullable(),

    /** The contact number of the supplier. */
    contact_number: z.string().nullable(),
})

export type Supplier = z.infer<typeof Supplier>

/** Supplier inside linked objects. */
export const SupplierBinding = Supplier.pick({
    id: true,
    name: true,
    client: true,
})

export type SupplierBinding = z.infer<typeof SupplierBinding>

export const SupplierPayload = Supplier.omit({
    id: true,
}).extend({
    client: ManagerBinding.shape.id,
})

export type SupplierPayload = z.infer<typeof SupplierPayload>

/** All suppliers returned by the API. */
export const SuppliersRequest = Pagination.extend({
    results: Supplier.array(),
})

export type SuppliersRequest = z.infer<typeof SuppliersRequest>
